import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import * as styles from './MapPreviewOnboarding.css';

interface IMapPreviewOnboardingProps extends React.PropsWithChildren {
  onClick(event: React.MouseEvent<HTMLElement>): void;
  text: React.ReactNode;
}

export const MapPreviewOnboarding: React.FC<IMapPreviewOnboardingProps> = ({ children, text, onClick }) => {
  return (
    <div className={styles['onboarding-wrapper']}>
      <div className={styles['onboarding']} role="button" onClick={onClick}>
        <UIText2 color="text-inverted-default">{text}</UIText2>
      </div>
      {children}
    </div>
  );
};
